import React from "react";
import Lottie from "react-lottie-player";
import loaderanimation from "./images/LoaderAnimation.json";

const LoaderAnimation = ({ loadingTxt = "" }) => {
  return (
    <div className="loadingindicator">
      <Lottie
        loop
        animationData={loaderanimation}
        play
        style={{ width: 64, height: 64 }}
      />
      <p className="loadingTxt">{loadingTxt}</p>
    </div>
  );
};

export default LoaderAnimation;
